import { useEffect, useState } from "react";
import { parseNowPlaying, type LiveTrack } from "./radio-now-playing";

// Poll a station's now-playing API for the live track, ~every 15s. Returns null
// when there's no URL, the feed fails, or the shape is unrecognised, callers
// fall back to the scheduled show. Transient errors are swallowed on purpose.
export function useNowPlayingTrack(url?: string, intervalMs = 15_000): LiveTrack | null {
  const [track, setTrack] = useState<LiveTrack | null>(null);

  useEffect(() => {
    if (!url) {
      setTrack(null);
      return;
    }
    let alive = true;
    const poll = async () => {
      try {
        const res = await fetch(url, { headers: { accept: "application/json" } });
        if (!res.ok) return;
        const json = await res.json();
        if (alive) setTrack(parseNowPlaying(json));
      } catch {
        /* transient, keep the last good value */
      }
    };
    poll();
    const id = setInterval(poll, intervalMs);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, [url, intervalMs]);

  return track;
}
